export const users = [
    { id: 0, name: 'Admin', pseudonym: '@admin', alternateId: '@admin_main', email: 'admin@bunchy.com', role: 'Admin', status: 'Active', avatar: 'dashboard', joinedDate: '2024-03-21', posts: 0, country: 'India' },
    { id: 1, name: 'John Doe', pseudonym: '@JD882', alternateId: '@john882', email: 'john@example.com', role: 'Admin', status: 'Active', avatar: 'male', joinedDate: '2024-01-15', posts: 45, country: 'India' },
    { id: 2, name: 'Jane Smith', pseudonym: '@JS991', alternateId: '@jane991', email: 'jane@example.com', role: 'User', status: 'Active', avatar: 'female', joinedDate: '2024-02-20', posts: 32, country: 'German' },
    { id: 3, name: 'Mike Johnson', pseudonym: '@MJ772', alternateId: '@mike772', email: 'mike@example.com', role: 'Moderator', status: 'Active', avatar: 'male', joinedDate: '2024-01-10', posts: 67, country: 'Spanish' },
    { id: 4, name: 'Sarah Williams', pseudonym: '@SW554', alternateId: '@sarah554', email: 'sarah@example.com', role: 'User', status: 'Inactive', avatar: 'female', joinedDate: '2024-03-05', posts: 12, country: 'French' },
    { id: 5, name: 'Tom Brown', pseudonym: '@TB123', alternateId: '@tom123', email: 'tom@example.com', role: 'User', status: 'Active', avatar: 'male', joinedDate: '2024-02-14', posts: 28, country: 'Nederland' },
    { id: 6, name: 'Emily Davis', pseudonym: '@ED441', alternateId: '@emily441', email: 'emily@example.com', role: 'User', status: 'Active', avatar: 'female', joinedDate: '2024-01-25', posts: 54, country: 'India' },
    { id: 7, name: 'David Wilson', pseudonym: '@DW223', alternateId: '@david223', email: 'david@example.com', role: 'Moderator', status: 'Active', avatar: 'male', joinedDate: '2024-02-01', posts: 89, country: 'German' },
    { id: 8, name: 'Lisa Anderson', pseudonym: '@LA112', alternateId: '@lisa112', email: 'lisa@example.com', role: 'User', status: 'Active', avatar: 'female', joinedDate: '2024-03-10', posts: 23, country: 'Spanish' },
];

export const countries = ['India', 'Germany', 'Spain', 'France', 'Netherlands', 'Belgium', 'USA'];

export const groups = [
    {
        id: 101, name: 'Sports Enthusiasts', members: 5432, posts: 1234, category: 'Sports', icon: 'football', status: 'Active', country: 'India',
        memberList: [
            { id: 'U-882', name: 'Puneet Kumar', avatar: 'racecar', role: 'Leader' },
            { id: 'U-991', name: 'Rahul Sharma', avatar: 'cricket', role: 'Member' },
            { id: 'U-772', name: 'Amit Singh', avatar: 'football', role: 'Member' },
            { id: 'U-554', name: 'Sonia Gupta', avatar: 'tennis', role: 'Member' },
            { id: 'U-123', name: 'Vikram Adi', avatar: 'basketball', role: 'Member' }
        ]
    },
    {
        id: 102, name: 'Tech Innovators', members: 4321, posts: 987, category: 'Technology', icon: 'laptop', status: 'Active', country: 'German',
        memberList: [
            { id: 'U-441', name: 'Aryan Dev', avatar: 'laptop', role: 'Admin' },
            { id: 'U-223', name: 'Neha Varma', avatar: 'mobile', role: 'Member' },
            { id: 'U-112', name: 'Kabir Das', avatar: 'robot', role: 'Member' },
            { id: 'U-665', name: 'Isha Khan', avatar: 'rocket', role: 'Member' },
            { id: 'U-009', name: 'Rohan Mehta', avatar: 'bolt', role: 'Member' }
        ]
    },
    {
        id: 103, name: 'Food Lovers', members: 3210, posts: 765, category: 'Food', icon: 'pizza', status: 'Active', country: 'French',
        memberList: [
            { id: 'U-331', name: 'Meera Roy', avatar: 'utensils', role: 'Member' },
            { id: 'U-552', name: 'Arjun Sen', avatar: 'rice', role: 'Member' },
            { id: 'U-886', name: 'Tina Lodi', avatar: 'cupcake', role: 'Member' },
            { id: 'U-447', name: 'Yash Raj', avatar: 'burger', role: 'Member' },
            { id: 'U-119', name: 'Pooja Jha', avatar: 'noodles', role: 'Member' }
        ]
    },
];

export const posts = [
    {
        id: 1,
        title: 'Amazing sunset at the beach',
        content: 'Found this hidden gem of a beach yesterday. The water was crystal clear and the sunset was absolutely magical...',
        author: { name: 'John Doe', avatar: 'male', id: 'U-001', pseudonym: '@JD882', country: 'India' },
        group: { name: 'Travel Bugs', icon: 'plane', id: 'G-104', country: 'India' },
        likes: 234, comments: 45, date: '2024-02-05', status: 'Active', flags: []
    },
    {
        id: 2,
        title: 'New JavaScript framework released',
        content: 'The new version finally supports native signals and improved build times. Here is my first impression...',
        author: { name: 'Mike Johnson', avatar: 'male', id: 'U-003', pseudonym: '@MJ772', country: 'Spanish' },
        group: { name: 'Tech Innovators', icon: 'laptop', id: 'G-102', country: 'German' },
        likes: 567, comments: 11, date: '2024-02-04', status: 'Trending', flags: ['Spam', 'Misleading']
    },
    {
        id: 3,
        title: 'Best pizza recipe ever!',
        content: 'The secret is in the double-fermented dough. 48 hours in the fridge makes all the difference in texture...',
        author: { name: 'Jane Smith', avatar: 'female', id: 'U-002', pseudonym: '@JS991', country: 'German' },
        group: { name: 'Food Lovers', icon: 'pizza', id: 'G-103', country: 'French' },
        likes: 432, comments: 67, date: '2024-02-03', status: 'Reported', flags: ['Inappropriate', 'Inappropriate', 'Inappropriate']
    },
    {
        id: 4,
        title: 'Morning workout routine',
        content: 'Consistency is key. 15 minutes of dynamic stretching followed by high-intensity intervals...',
        author: { name: 'Emily Davis', avatar: 'female', id: 'U-006', pseudonym: '@ED441', country: 'German' },
        group: { name: 'Fitness Freaks', icon: 'dumbbell', id: 'G-106', country: 'India' },
        likes: 345, comments: 56, date: '2024-02-02', status: 'Active', flags: []
    },
    {
        id: 5,
        title: 'Book recommendation: The Great Novel',
        content: 'Just finished reading this masterpiece. The way it explores human nature and society is profound...',
        author: { name: 'Lisa Anderson', avatar: 'female', id: 'U-008', pseudonym: '@LA112', country: 'Spanish' },
        group: { name: 'Book Club', icon: 'book', id: 'G-105', country: 'Nederland' },
        likes: 198, comments: 34, date: '2024-02-01', flags: []
    },
];

export const ads = [
    {
        id: 'ad1',
        image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&q=80',
        text: 'Limited time offer! Get 30% off on all luxury watches. Upgrade your style today.',
        link: 'https://example.com/watches',
        country: 'India'
    },
    {
        id: 'ad2',
        image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&q=80',
        text: 'Experience pure sound. The new wireless headphones are here. Shop now!',
        link: 'https://example.com/audio',
        country: 'All'
    }
];

export const comments = [
    { id: 401, userId: 1, postTitle: 'New JavaScript framework released', content: 'This looks very promising! Can\'t wait to try it.', date: '2024-02-04 14:30' },
    { id: 402, userId: 1, postTitle: 'Best pizza recipe ever!', content: 'I tried this yesterday and it was delicious!', date: '2024-02-03 18:20' },
];

export const groupMessages = [
    { id: 501, groupId: 101, groupName: 'Sports Enthusiasts', userId: 1, userName: 'John Doe', avatar: 'male', content: 'Has anyone seen the game tonight?', date: '2024-02-06 20:30' },
];

export const privateMessages = [
    { id: 601, senderId: 1, senderName: 'Admin', senderAvatar: 'dashboard', receiverName: 'John Doe', receiverAvatar: 'male', content: 'System check complete.', date: '2024-02-07 09:00' },
];

export const conversations = [
    { id: 1, user1: 'Admin', user1Avatar: 'dashboard', user2: 'John Doe', user2Avatar: 'male', lastMsg: 'System check complete.', time: '10:30 AM' },
];

export const postLikes = [
    { postId: 1, users: [{ name: 'Jane Smith', avatar: 'female' }, { name: 'Mike Johnson', avatar: 'male' }] },
];

export const stats = [
    { id: 1, title: 'Total Users', value: '12,543', change: '+12.5%', type: 'users_nav', color: '#2B7FD9' },
    { id: 2, title: 'Active Groups', value: '1,234', change: '+8.2%', type: 'groups_nav', color: '#10B981' },
    { id: 3, title: 'Total Posts', value: '45,678', change: '+23.1%', type: 'posts_nav', color: '#F59E0B' },
    { id: 4, title: 'Revenue', value: '$89,432', change: '+15.3%', type: 'revenue', color: '#8B5CF6' },
];

export const activityData = [
    { name: 'Mon', posts: 42, comments: 124, activeUsers: 2100 },
];

export const growthData = [
    { name: 'Jan', users: 8400 },
];

export const roles = [
    { id: 1, name: 'Super Admin', members: 2, permissions: 'Full System Access', color: '#ef4444', icon: 'shield' },
    { id: 2, name: 'Admin', members: 5, permissions: 'User & Content Management', color: '#2B7FD9', icon: 'tool' },
    { id: 3, name: 'Moderator', members: 12, permissions: 'Content & Chat Auditing', color: '#10B981', icon: 'activity' },
    { id: 4, name: 'Support', members: 8, permissions: 'User Assistance & Flags', color: '#F59E0B', icon: 'phone' },
    { id: 5, name: 'User', members: 12516, permissions: 'Standard Access', color: '#6B7280', icon: 'male' },
];

